<template>
  <div class="smsc-container">
    <vx-card>
      <!-- Per Page -->
      <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
        <per-page
          :currentPerPage="per_page"
          :pageStart="pageStart"
          :pageEnd="pageEnd"
          :total="total"
          @change-per-page="ChangePerPage($event)"
        />
      </div>

      <!-- Table -->
      <ag-grid-vue
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="list"
        @gridReady="GridReady"
        @filterChanged="Filtering"
        @selectionChanged="SelectionChanged"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        >
      </ag-grid-vue>

      <!-- Pagination -->
      <vs-pagination
        :total="totalPages"
        :max="maxPageNumbers"
        v-model="Page"
        />
    </vx-card>
  </div>
</template>

<script>
// Mixins
import TableMixin from '@/mixins/table.js'

// Packages
import { format } from 'date-fns'
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'

// Cell Renderer components
// import CellRendererActions from './cell-renderer/CellRendererActions'

export default {
  mixins: [TableMixin],
  components: {
    AgGridVue,

    //Cell Renderer components
    // CellRendererActions
  },
  data() {
    return {
      // Selected did
      selected_did: [],
      searchProduct: '',
      items:[{
        "uuid": "8e7558ab-4a83-4700-8575-eed76efb14ec",
        "on_duplicate": "skip",
        "created_on": "2020-10-02T14:58:33.505265+00:00",
        "finished_on": null,
        "reply": null,
        "on_error": "abort",
        "ani_group_uuid": null,
        "reseller_uuid": "c668a2a8-2087-44e1-bcdc-7d9dc8df120c",
        "status": "0",
        "company_uuid": null,
        "file_name":"numbers",
        "total":200,
        "success":100,
        "fail":100,
        "file": "numbers.csv",
        "command": "ani",
        "created_by": "admin",
        "country_uuid": null,
        "vendor_uuid": null,
        "orig_file": null,
        "user_id": null,
        "result": null
      },
        {
          "uuid": "8e7558ab-4a83-4700-8575-eed76efb14ec",
          "on_duplicate": "skip",
          "created_on": "2020-10-02T14:58:33.505265+00:00",
          "finished_on": null,
          "reply": null,
          "on_error": "abort",
          "ani_group_uuid": null,
          "reseller_uuid": "c668a2a8-2087-44e1-bcdc-7d9dc8df120c",
          "status": "0",
          "company_uuid": null,
          "file_name":"numbers",
          "file": "numbers.csv",
          "success":260,
          "fail":40,
          "total":300,
          "command": "ani",
          "created_by": "admin",
          "country_uuid": null,
          "vendor_uuid": null,
          "orig_file": null,
          "user_id": null,
          "result": null
        },
        {
          "uuid": "8e7558ab-4a83-4700-8575-eed76efb14ec",
          "on_duplicate": "skip",
          "created_on": "2020-10-02T14:58:33.505265+00:00",
          "finished_on": null,
          "reply": null,
          "on_error": "abort",
          "ani_group_uuid": null,
          "reseller_uuid": "c668a2a8-2087-44e1-bcdc-7d9dc8df120c",
          "status": "0",
          "company_uuid": null,
          "file_name":"numbers",
          "total":200,
          "file": "numbers.csv",
          "command": "ani",
          "success":50,
          "fail":150,
          "created_by": "admin",
          "country_uuid": null,
          "vendor_uuid": null,
          "orig_file": null,
          "user_id": null,
          "result": null
        },
        {
          "uuid": "8e7558ab-4a83-4700-8575-eed76efb14ec",
          "on_duplicate": "skip",
          "created_on": "2020-10-02T14:58:33.505265+00:00",
          "finished_on": null,
          "reply": null,
          "on_error": "abort",
          "ani_group_uuid": null,
          "reseller_uuid": "c668a2a8-2087-44e1-bcdc-7d9dc8df120c",
          "status": "0",
          "company_uuid": null,
          "file_name":"numbers",
          "file": "numbers.csv",
          "total":500,
          "success":400,
          "fail":100,
          "command": "ani",
          "created_by": "admin",
          "country_uuid": null,
          "vendor_uuid": null,
          "orig_file": null,
          "user_id": null,
          "result": null
        },
        {
          "uuid": "8e7558ab-4a83-4700-8575-eed76efb14ec",
          "on_duplicate": "skip",
          "created_on": "2020-10-02T14:58:33.505265+00:00",
          "finished_on": null,
          "reply": null,
          "on_error": "abort",
          "ani_group_uuid": null,
          "reseller_uuid": "c668a2a8-2087-44e1-bcdc-7d9dc8df120c",
          "status": "0",
          "company_uuid": null,
          "file_name":"numbers",
          "total":100,
          "file": "numbers.csv",
          "command": "ani",
          "success":70,
          "fail":30,
          "created_by": "admin",
          "country_uuid": null,
          "vendor_uuid": null,
          "orig_file": null,
          "user_id": null,
          "result": null
        },],
      // table header value
      columnDefs: [
        {
          headerName: 'Uploaded On',
          // field: 'uploaded_on',
          field: 'created_on',

        //   minWidth: 240,
          sortable: true,
        },
        {
          headerName: 'Uploaded By',
          field: 'created_by',
        //   minWidth: 200,
          sortable: true
        },
        {
          headerName: 'File Name',
          field: 'file_name',
        //   minWidth: 160
        },
        {
          headerName: 'Total',
          field: 'total',
        //   filter: true,
        //   minWidth: 220
        },
        {
          headerName: 'Success',
          field: 'success',
        //   filter: true,
        //   minWidth: 220
        },
        {
          headerName: 'FAil',
          field: 'fail',
        //   minWidth: 120
        },
      ],

      // Cell Renderer components
      components: {
        // CellRendererActions
      }
    }
  },
  computed: {
    activeDeletionButton () {
      return this.selected_did.length ? false : true
    }
  },
  created() {
    this.GetList()
  },
  methods: {
    GetList() {
      this.list= this.items
      /*this.$vs.loading()
      this.$store.dispatch('did/GetList', {
        ...this.filters,
        page: this.page || 0,
        per_page: this.per_page || 20,
        order_by: this.order_by || null,
        order_dir: this.order_dir || null,
        did: this.searchProduct
      })
      .then(res => {
        this.list = res.items.map(this.TransformList)
        this.total = res.total
      })
      .catch(err => this.ShowErrorMessage({ title: 'Error', text: err }))
      .finally(() => this.$vs.loading.close())*/
    },

    SelectionChanged () {
      const selected_data = this.gridApi.getSelectedNodes()
      this.selected_did = selected_data.map(this.TransformSelectedDid)
    },
    ConfirmDelete () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Are you sure?',
        text: 'You will not be able to recover this DIDs!',
        accept: this.DeleteSelection,
        acceptText: 'Delete'
      })
      // this.params.data.refreshData()
    },
    DeleteSelection () {
      this.$vs.loading()
      this.$store.dispatch('did/MassDelete', { items: this.selected_did })
      .then(() => {
        console.log('then')
        this.GetList()
        this.ShowSuccessMessage({
          title: 'Deleted',
          text: 'The selected DIDs were successfully deleted'
        })
      })
      .catch(err => this.ShowErrorMessage({ title: 'Error', text: err }))
      .finally(() => this.$vs.loading.close())
    },

    // Notify
    ShowSuccessMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-check',
        color: 'success',
        title,
        text
      })
    },
    ShowErrorMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger',
        title,
        text
      })
    },

    // Transform functions
    TransformList(item) {
      return {
        did: item.did,
        created_on: format(new Date(item.created_on), 'yyyy:MM:dd HH:mm:ss'),
        created_by: item.created_by,
        vendor_name: item.vendor_name,
        company_name: item.company_name,
        iso3: item.iso3,
        did_type: item.did_type,
        state: item.state,
        lata: item.lata
      }
    },
    TransformSelectedDid (item) {
      return item.data.did
    },
    onQuickFilterChanged() {
      this.GetList()
    },
  }
}
</script>
<style>
.vs-pagination--li {
    width:auto;
    min-width:35px;
}
    .filter_input_did{
        padding: 17px;
        padding-left: 55px;
        width: 300px;
        border: 1px solid #f5f5f5;
        font-size: 13px;
        color: gray;
        background-repeat: no-repeat;
        background-position: left center;
        outline: 0;
    }
    .has-search .form-control-feedback {
        position: absolute;
        z-index: 2;
        display: block;
        width: 15px;
        height: 15px;
        line-height: 2.375rem;
        text-align: center;
        pointer-events: none;
        color: gray;
        margin-left: 30px;
        margin-top: 20px;
    }
</style>
